import {AfterContentInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {LoginService} from "../../login/login.service";
import {Router} from "@angular/router";
import {MainMenuService} from "./main-menu.service";
import {BreadcumbsService} from "../../breadcumbs/breadcumbs.service";
import {CommonService} from "../../../common/common.service";
import {NotificationType} from "../../notifier/notification-type.enum";
import {NotifierService} from "../../notifier/notifier.service";
import {MainMenu} from "./main-menu.enum";
import {UserReportsService} from "../../user-reports/user-reports.service";
import {Report} from "../../../model/report";
import {NgbCalendarGregorian} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";

@Component({
  selector: 'pbc-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls :['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit{

  @Input() userInitials: string;
  @Input() isUserLogged: boolean;
  @Input() isAdmin : boolean;
  @Input() userFirstName: string;
  @Input() userLastName: string;
  @Input() userEmail: string;
  @Input() userId: number;

  private ngbCalendar = new NgbCalendarGregorian();
  mainMenuEnum = MainMenu;
  activeMenu : MainMenu;
  userNewReports : Array<Report> = [];
  userMenuReports: Array<Report> = [];
  newReportsCounter : number = 0;
  gotoNewReportsClicked = false;

  constructor(private loginService: LoginService,
              private router : Router,
              private breadcumbsService: BreadcumbsService,
              private mainMenuService : MainMenuService,
              private commonService : CommonService,
              private userReportsService: UserReportsService,
              private notifierService : NotifierService,
  ) {
    this.activeMenu = this.mainMenuEnum.None;
  }

  ngOnInit(): void {
    if (this.isUserLogged && !this.isAdmin) {
      this.setNewReportsNumber();
      this.getNewReports();
    }
  }

  setNewReportsNumber() : void {
    let filterParams = {};

    let dateFrom = this.ngbCalendar.getToday();
    //Szukamy raportów opublikowanych miesiąc wstecz
    dateFrom = this.ngbCalendar.getPrev(dateFrom, "m", 1);

    filterParams['onlyNew'] = true;
    filterParams['published'] = true;
    filterParams['dateFrom'] = new Date(dateFrom.year, dateFrom.month -1, dateFrom.day);

    this.commonService.prefilterUserReports(filterParams).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        else
          this.newReportsCounter = result.record;
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
      }
    )
  }

  getNewReports() : void {
    let filterParams = {};
    filterParams['published'] = true;
    filterParams['sortString'] = 'shownToUser'
    filterParams['pageNumber'] = 1;

    let dateFrom = this.ngbCalendar.getToday();
    //Szukamy raportów opublikowanych miesiąc wstecz
    dateFrom = this.ngbCalendar.getPrev(dateFrom, "m", 1);
    filterParams['dateFrom'] = new Date(dateFrom.year, dateFrom.month -1, dateFrom.day);

    this.commonService.getUserReports(filterParams).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Bład w trakcie pobierania danych');
        else {
          this.userNewReports = result.record;
          this.userMenuReports = this.userNewReports.slice(0,5);
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych')
      }
    )
  }

  onLogout() {
    this.manageMenuVisibility('Logout');
    this.activeMenu = this.mainMenuEnum.None;
    this.loginService.logout();
  }

  onExternalServiceClick(folder : string) {
    this.manageMenuVisibility(folder);

    if (folder)
      this.commonService.registerClickOnElement('clickOnExternalService', 'menu', folder, null ).subscribe(
        success=>{
          if (success.status != 1)
            console.log(success.message);
        },
        error=>{
          console.log(error);
        }
      );
  }

  onUserContactClick(folder : string) {
    this.manageMenuVisibility(folder);

    this.commonService.registerClickOnElement('clickOnUserContact', 'menu', folder, null ).subscribe(
      success=>{
        if (success.status != 1)
          console.log(success.message);
      },
      error=>{
        console.log(error);
      }
    );
  }

  manageMenuVisibility(folder:string) {
    this.breadcumbsService.setSubfolder.emit(folder);
    this.mainMenuService.deactivateTopMenuActivePosition.emit(true);
  }

  activateMenu(menu : MainMenu) {
    this.activeMenu = menu;
  }

  deactivateMenu() {
    //jeśli dezaktywwowane menu to nowe raporty,
    if (this.activeMenu == MainMenu.NewReports) {
      let reportsToUpdate : Array<Report> = [];
      for (let report of this.userNewReports)
        if (report.shownToUser == false) {
          reportsToUpdate.push(report);
          report.shownToUser = true;
        }
      this.newReportsCounter -= reportsToUpdate.length;
      if (reportsToUpdate.length > 0) {
        this.mainMenuService.markReportAsShown.emit(reportsToUpdate);
        let reportsToUpdateIds = reportsToUpdate.map(report=>report.id);
        this.userReportsService.markAsShownOnUserList(reportsToUpdateIds, this.userId).subscribe(
            date => {
              console.log(date);
            },
            error => {
              console.error(error)
            }
        )
      }
    }

    this.activeMenu = this.mainMenuEnum.None;
  }

  onNewReportsClick() {
    this.gotoNewReportsClicked = true;
  }
}
